import { render, staticRenderFns } from "./pubsuccess.vue?vue&type=template&id=3edb7439&scoped=true"
import script from "./pubsuccess.vue?vue&type=script&lang=js"
export * from "./pubsuccess.vue?vue&type=script&lang=js"
import style0 from "./pubsuccess.vue?vue&type=style&index=0&id=3edb7439&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb7439",
  null
  
)

export default component.exports